import * as Sentry from '@sentry/react';
import React from 'react';
import { render } from 'react-dom';
import { applyErrorHintToSentryEvent, getSentryOptions, initAmplitude } from 'utils';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import App from './App';

const SENTRY_DSN = 'https://7a74665475fea462eaf9f30a2297877b@try-cosmos.helios.vg/927';
const sentryOptions = getSentryOptions({
  dsn: SENTRY_DSN,
  beforeSend: (event, hint) => applyErrorHintToSentryEvent({ event, hint }),
});

Sentry.init(sentryOptions);

Sentry.setTag('package', 'stockplus-news');

initAmplitude('STOCKPLUS-NEWS');
const root = document.createElement('div');
root.setAttribute('class', 'root');
document.body.appendChild(root);

render(<App />, root);
